import { zergApi } from "@/service/zerg";

const prefix = "/rrhh/cts";

class CtsService {
  async index(params) {
    try {
      const data = await zergApi.post(`${prefix}/index`, params);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async generar(params) {
    try {
      const data = await zergApi.post(`${prefix}/generar`, params);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async getPeriodos() {
    try {
      const data = await zergApi.post(`${prefix}/get-periodos`);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async aprobar(params) {
    try {
      const data = await zergApi.post(`${prefix}/aprobar`, params);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async preGenerar(params) {
    try {
      const data = await zergApi.post(`${prefix}/pre-generar`, params);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async show(params) {
    try {
      const data = await zergApi.post(`${prefix}/show`, params);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async consultar(batchId) {
    try {
      const data = await zergApi.get(`${prefix}/consultar/${batchId}`);
      return data;
    } catch (error) {
      throw error;
    }
  }
}

export default new CtsService();
